import React, {useState, useContext, useEffect} from 'react';
import {Tooltip, Typography} from 'antd';
import {TagFilled} from '@ant-design/icons';
import {MarkdownBlock} from '../markdown-block';
import {TextBlock} from '../text-block';
import {TagBlock} from '../tag-block';
import {Block} from '../block';
import {OpenApiContext} from '../../openapi-context';

export function InterfaceHeaderBlock({intf, canEdit, onSave, onCancel, setTag, rootPath, mobile}) {
    const [editMode, setEditMode] = useState(false);
    const [summary, setSummary] = useState();
    const [description, setDescription] = useState('');
    const {dispatch, state} = useContext(OpenApiContext);

    useEffect(() => {
        if (intf) {
            setSummary(intf.spec.summary ? intf.spec.summary : '');
            setDescription(intf.spec.description ? intf.spec.description : '');
        }
    }, [intf]);

    function setTagsTitle(intf) {
        let tagTitle;
        if (intf.spec['tags'] && intf.spec['tags'].length > 0) {
            if (intf.spec['tags'].length > 1) {
                tagTitle = `${intf.spec['tags'][0]} + ${intf.spec['tags'].length - 1}`;
            } else {
                tagTitle = intf.spec['tags'][0];
            }
        } else {
            tagTitle = '';
        }
        return tagTitle;
    }

    function handleCancel() {
        dispatch({type: 'terminate'});
        setEditMode(false);
        return onCancel && onCancel();
    }

    const triggerEdit = () => {
        setEditMode(true);
        dispatch({type: 'activate', message: `changes to interface ${intf.key}`});
    };

    const handleSave = () => {
        dispatch({type: 'terminate'});
        setEditMode(false);
        intf.spec.summary = summary;
        intf.spec.description = description;
        onSave && onSave(intf.spec);
    };

    return (
        <Block name={`interface ${intf.key}`} onEdit={triggerEdit} onCancel={handleCancel} onSave={handleSave} mobile={mobile}>
            {setTagsTitle(intf) && (
                <Typography.Title level={3} ellipsis={true} style={{display: 'flex', alignItems: 'baseline'}}>
                    <TagFilled width="2em" />

                    <Tooltip placement="right" title={intf.spec['tags'] && intf.spec['tags'].length > 0 ? intf.spec['tags'].join() : 'Tags'}>
                        <span style={{marginLeft: 10}}>{setTagsTitle(intf)}</span>
                    </Tooltip>
                </Typography.Title>
            )}

            <TagBlock hiddenValue={true} value={intf.spec.tags} placeholder="Tag" onValue={setTag} delegatedEditMode={editMode} />
            <TextBlock
                value={summary}
                onValue={(val) => setSummary(val)}
                placeholder="Summary. An optional, string summary, intended to apply to all operations in this path"
                delegatedEditMode={editMode}
            />
            <MarkdownBlock
                source={description}
                onValue={(val) => setDescription(val)}
                placeholder={
                    <span>
                        <strong>Description</strong>. An optional, string description, intended to apply to all operations in this path. CommonMark syntax MAY be used for rich text representation.
                    </span>
                }
                delegatedEditMode={editMode}
                imageRootPath={rootPath}
            />
        </Block>
    );
}
